import React from 'react'
import ReactApexChart from 'react-apexcharts'

import { get } from 'lodash'

export const barChartProps = (data = [], categories = [], chartName = '') => {
  return {
    series: data,
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
          tools: {
            download: false
          }
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '20%'
        }
      },
      title: {
        text: chartName
      },
      xaxis: {
        categories,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        }
      },
      colors: ['#fff', '#fff', '#fff', '#fff'],
      axisTicks: {
        show: false
      },
      legend: {
        show: false
      },
      fill: {
        opacity: 1,
        type: 'solid'
      }
    }
  }
}

export const columnChartProps = (data = [], categories = [], chartName = '') => {
  return {
    series: data,
    options: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        }
      },
      title: {
        text: chartName
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        }
      },
      yaxis: {
        title: {
          text: 'Qtd visitas'
        }
      },
      colors: ['#fff', '#fff', '#fff', '#fff'],
      axisTicks: {
        show: false
      },
      legend: {
        show: false
      },
      fill: {
        opacity: 1,
        type: 'solid'
      }
    }
  }
}

export const lineChartProps = (data = [], categories = []) => {
  return {
    series: [
      {
        data
      }
    ],
    options: {
      chart: {
        type: 'bar',
        toolbar: {
          tools: {
            download: false
          }
        }
      },
      title: {
        text: 'Profissionais Visitas Realizadas'
      },
      axisTicks: {
        show: false
      },
      plotOptions: {
        bar: {
          horizontal: true
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        }
      },
      colors: ['#4AB396'],
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0,
          opacityTo: 0.8,
          stops: [0, 50, 100]
        }
      }
    }
  }
}

export const treeMapChart = (data = [], options = {}) => {
  return {
    series: [
      {
        data: [...data]
      }
    ],
    options: {
      width: 600,
      height: 500,
      chart: {
        type: 'treemap',
        toolbar: {
          show: false
        },
        events: {
          click(event, chartContext, config) {
            // Console.log(config.config.series[config.seriesIndex].data[config.dataPointIndex])
            console.log('config===>', config)
          }
        }
      },
      colors: ['#843EF7'],
      legend: {
        show: false
      },
      dataLabels: {
        formatter(text, { value }) {
          return [
            text.length >= 7 ? `${text.slice(0, 8)}...` : text,
            value.toString().length <= 3 ? value : `${value.toLocaleString('pt-BR')} ha`
          ]
        },
        enabled: true,
        offsetX: 0,
        style: {
          fontSize: '12px',
          colors: ['#fff']
        }
      },
      tooltip: {
        x: {
          show: false
        },
        y: {
          formatter(value) {
            return value.toString().length <= 3 ? value : `${value.toLocaleString('pt-BR')} ha`
          }
        }
      },
      ...options
    }
  }
}

export const stackedBarChart = (data) => {
  return {
    series: [...data],
    options: {
      dataLabels: {
        formatter(text) {
          return [text === 0 ? '' : `${parseInt(text)}%`]
        },
        enabled: true,
        offsetX: 0,
        style: {
          fontSize: '12px',
          colors: ['#fff']
        }
      },
      states: {
        hover: {
          filter: {
            type: 'none'
          }
        }
      },
      width: 815,
      height: 90,
      chart: {
        toolbar: {
          show: false
        },
        type: 'bar',
        height: 0,
        stacked: true,
        stackType: '100%'
      },
      xaxis: {
        show: false,
        labels: {
          show: false
        },
        axisTicks: {
          show: false
        },
        axisBorder: {
          show: false
        }
      },
      yaxis: {
        show: false,
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        title: {
          text: undefined
        },
        crosshairs: {
          show: false
        },
        tooltip: {
          enabled: false
        }
      },
      fill: {
        colors: ['#04D1D1', '#FFB40B', '#369EFF', '#E21D45']
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '100%'
        }
      },
      stroke: {
        show: false
      },
      grid: {
        show: false,
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      },
      legend: {
        show: false
      },
      tooltip: {
        enabled: false
      }
    }
  }
}

export const progressBarChart = (data, options = {}) => {
  return {
    series: [...data],
    options: {
      states: {
        hover: {
          filter: {
            type: 'none'
          }
        }
      },
      width: 235,
      height: 65,
      chart: {
        toolbar: {
          show: false
        },
        type: 'bar',
        height: 0,
        stacked: true,
        stackType: '100%'
      },
      xaxis: {
        show: false,
        labels: {
          show: false
        },
        axisTicks: {
          show: false
        },
        axisBorder: {
          show: false
        }
      },
      yaxis: {
        show: false,
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        title: {
          text: undefined
        },
        crosshairs: {
          show: false
        },
        tooltip: {
          enabled: false
        }
      },
      fill: {
        colors: ['#843EF7', '#D6DAE0']
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#fff', 'none']
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '100%'
        }
      },
      stroke: {
        show: false
      },
      grid: {
        show: false,
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      },
      legend: {
        show: false
      },
      tooltip: {
        enabled: false
      },
      ...options
    }
  }
}

export const dountchart = (data) => {
  return {
    series: [...data],
    options: {
      states: {
        hover: {
          filter: {
            type: 'none'
          }
        }
      },
      width: 200,
      height: 200,
      chart: {
        type: 'donut'
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                show: true,
                fontWeight: 600,
                fontSize: '15px',
                color: '#334863',
                formatter: () => 'Total'
              },
              total: {
                show: true,
                showAlways: false,
                label: 'Total',
                fontSize: '15px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                color: '#334863',
                formatter(w) {
                  return w.globals.seriesTotals.reduce((a, b) => {
                    return a + b
                  }, 0)
                }
              }
            }
          }
        }
      },
      fill: {
        colors: ['#E21D45', '#04D1D1']
      },
      labels: ['Sim', 'Não'],
      legend: {
        show: false
      },
      tooltip: {
        enabled: false
      }
    }
  }
}

export const multipleChart = (data) => {
  return {
    series: data.columns,
    options: {
      chart: {
        height: 350,
        type: 'line',
        stacked: false,
        toolbar: {
          show: false
        }
      },
      width: 700,
      height: 450,
      dataLabels: {
        enabled: true,
        offsetX: 0,
        offsetY: -8,
        background: 'transparent',
        style: {
          fontSize: '12px',
          colors: ['#B58BFA', '#68E3E3']
        }
      },
      states: {
        hover: {
          filter: {
            type: 'none'
          }
        }
      },
      stroke: {
        width: [1, 1]
      },
      xaxis: {
        categories: data.xAxis,
        labels: {
          show: true,
          style: {
            colors: '#8591A1'
          }
        },
        tooltip: {
          enabled: false
        }
      },
      yaxis: [
        {
          axisBorder: {
            show: true,
            color: '#8591A1'
          },
          labels: {
            show: true,
            formatter(text) {
              return text + 'k'
            },
            style: {
              colors: '#8591A1'
            }
          },
          tooltip: {
            enabled: false
          }
        }
      ],
      tooltip: {
        enabled: false
      },
      legend: {
        show: false
      }
    }
  }
}

export const renderChart = ({ chart }) => {
  const options = get(chart, 'options', {})
  const series = get(chart, 'series', [])

  return (
    <>
      {options.chart !== undefined ? (
        <ReactApexChart
          options={options}
          series={series}
          type={options.chart.type}
          style={style[options.chart.type]}
          height={options.height}
          width={options.width}
        />
      ) : null}
    </>
  )
}

const style = {
  treemap: {},
  chart: {
    width: '90%',
    padding: '1rem',
    minHeight: '50%',
    margin: '1rem'
  }
}
